<template>
  <div>
    <div class="text-center my-5">
      <img src="@/assets/404.svg" alt="Site" style="object-fit: cover" height="50%" width="50%" class="animated bounce infinite">
    </div>
    <div class="text-center animated bounceInDown">
      <span class="h1 mx-4 ">Page Not Found</span>
    </div>
  </div>
</template>

<script lang="ts">
import Vue from 'vue'
export default Vue.extend({

})
</script>
